define('datakit/util/enable.relationship.lazy.loading',['require','exports','module','backbone','backbone.radio'],function(require, exports, module) {
  var Backbone = require('backbone');
  var Radio    = require('backbone.radio');

  
  function enableRelationshipLazyLoading(resource) {
    if (resource instanceof Backbone.Collection) {
      resource.each(enableRelationshipLazyLoading);
    }
    else if (resource instanceof Backbone.Model) {
      if (resource.enableRelationshipLazyLoading) {
        resource.enableRelationshipLazyLoading();
      } else {
        resource.lazyLoadingEnabled = true;
      }
      if (resource.eachChildResource) {
        resource.eachChildResource(enableRelationshipLazyLoading);
      }
      if (resource.eachRelationshipResource) {
        resource.eachRelationshipResource(enableRelationshipLazyLoading);
      }
    }
  };

  Radio.reply('DataKit', 'enableRelationshipLazyLoading', enableRelationshipLazyLoading);
  module.exports = enableRelationshipLazyLoading;
});
